import i18n from '@buy-viasat/utils/src/lib/config/i18n';
import serviceabilityEnUS from './locales/en-US/serviceability.json';

i18n.addResourceBundle('en-US', 'serviceability', serviceabilityEnUS);

export default i18n;
